import React, { useRef, useEffect, useContext, useState } from "react";
import Typed from "typed.js";
import { motion } from "framer-motion/dist/framer-motion";
import HtmlIcon from "./assets/skills/html.svg";
import CssIcon from "./assets/skills/css.svg";
import SassIcon from "./assets/skills/sass.svg";
import BootstrapIcon from "./assets/skills/bootstrap.png";
import TailwindIcon from "./assets/skills/Tailwind.png";
import JavascriptIcon from "./assets/skills/javascript.svg";
import TypescriptIcon from "./assets/skills/TypeScript.png";
import JQueryIcon from "./assets/skills/jquery.svg";
import ReactIcon from "./assets/skills/react.svg";
import NodeJsIcon from "./assets/skills/NodeJS.png";
import CSharpIcon from "./assets/skills/csharp.svg";
import BlazorIcon from "./assets/skills/blazor.svg";
import DotNetIcon from "./assets/skills/dotnet.png";
import GraphQLIcon from "./assets/skills/graphql.png";
import SqlServerIcon from "./assets/skills/SqlServer.png";
import MySqlIcon from "./assets/skills/mysql.svg";
import EntityFrameworkIcon from "./assets/skills/entity-framework.png";
import TypeOrmIcon from "./assets/skills/typeORM.png";
import ApiIcon from "./assets/skills/api.svg";
import GitIcon from "./assets/skills/git.svg";
import VsCodeIcon from "./assets/skills/vscode.svg";
import NPMIcon from "./assets/skills/npm.svg";
import YarnIcon from "./assets/skills/Yarn.png";
import AzureIcon from "./assets/skills/azure.png";
import MongoDBIcon from "./assets/skills/mongodb.png";
import { headingVariant, containerVariant, itemVariant } from "./PageVariants";
import { NavContext } from "./App";
import { InView } from "react-intersection-observer";

export default function Skills({ pageRef }) {
	const typedElementForSub = useRef(null);
	const typedElementForHeading = useRef(null);
	const setSelectedNav = useContext(NavContext);
	const [isInView, setIsInView] = useState(false);
	const skillsList = [
		{
			Image: ReactIcon,
			Name: "React",
			Rating: 7,
			Color: "rgb(103 219 251)",
		},
		{
			Image: NodeJsIcon,
			Name: "Node JS",
			Rating: 7,
			Color: "rgb(95 165 81)",
		},
		{
			Image: CSharpIcon,
			Name: "C#",
			Rating: 9,
			Color: "rgb(154 73 147)",
		},
		{
			Image: BlazorIcon,
			Name: "Blazor",
			Rating: 9,
			Color: "rgb(112 42 247)",
		},
		{
			Image: DotNetIcon,
			Name: ".NET",
			Rating: 9,
			Color: "rgb(80 39 213)",
		},
		{
			Image: GraphQLIcon,
			Name: "GraphQL",
			Rating: 6,
			Color: "rgb(231 56 175)",
		},
		{
			Image: SqlServerIcon,
			Name: "SQL Server",
			Rating: 9,
			Color: "rgb(203 108 107)",
		},
		{
			Image: MySqlIcon,
			Name: "MySql",
			Rating: 7,
			Color: "rgb(50 118 136)",
		},
		{
			Image: MongoDBIcon,
			Name: "MongoDB",
			Rating: 7,
			Color: "rgb(84 173 69)",
		},
		{
			Image: EntityFrameworkIcon,
			Name: "Entity Framework",
			Rating: 9,
			Color: "rgb(103 32 121)",
		},
		{
			Image: TypeOrmIcon,
			Name: "Type ORM",
			Rating: 7,
			Color: "rgb(237 95 79)",
		},
		{
			Image: TypescriptIcon,
			Name: "Typescript",
			Rating: 7,
			Color: "rgb(45 121 199)",
		},
		{
			Image: JavascriptIcon,
			Name: "Javascript",
			Rating: 8,
			Color: "rgb(247 223 30)",
		},
		{
			Image: JQueryIcon,
			Name: "JQuery",
			Rating: 6,
			Color: "rgb(33 96 155)",
		},
		{
			Image: ApiIcon,
			Name: "REST APIs",
			Rating: 9,
			Color: "rgb(64 122 222)",
		},
		{
			Image: GitIcon,
			Name: "Git",
			Rating: 7,
			Color: "rgb(222 76 54)",
		},
		{
			Image: HtmlIcon,
			Name: "HTML",
			Rating: 8,
			Color: "rgb(228 77 38)",
		},
		{
			Image: CssIcon,
			Name: "CSS",
			Rating: 8,
			Color: "rgb(38 77 228)",
		},
		{
			Image: SassIcon,
			Name: "Sass",
			Rating: 7,
			Color: "rgb(210 111 161)",
		},
		{
			Image: BootstrapIcon,
			Name: "Bootstrap",
			Rating: 9,
			Color: "rgb(139 11 252)",
		},
		{
			Image: TailwindIcon,
			Name: "Tailwind",
			Rating: 9,
			Color: "rgb(22 189 202)",
		},
		{
			Image: VsCodeIcon,
			Name: "VS Code",
			Rating: 9,
			Color: "rgb(36 137 202)",
		},
		{
			Image: NPMIcon,
			Name: "npm",
			Rating: 7,
			Color: "rgb(203 56 55)",
		},
		{
			Image: YarnIcon,
			Name: "yarn",
			Rating: 7,
			Color: "rgb(54 143 185)",
		},
		{
			Image: AzureIcon,
			Name: "Azure",
			Rating: 7,
			Color: "rgb(20 101 191)",
		},
		{
			Image: null,
			Name: "and many more...",
			Rating: 0,
			Color: "rgb(54 143 185)",
		},
	];

	useEffect(() => {
		let typedSub = new Typed(typedElementForSub.current, {
			strings: ["CHECKOUT MY"],
			startDelay: 0,
			typeSpeed: 40,
			showCursor: false,
		});

		let typedHeading = new Typed(typedElementForHeading.current, {
			strings: ["SKILLS"],
			startDelay: 800,
			typeSpeed: 80,
			showCursor: false,
		});

		return () => {
			typedSub.destroy();
			typedHeading.destroy();
		};
	}, [isInView]);

	const viewChange = (inView) => {
		setIsInView(inView);
		if (inView) {
			setSelectedNav({ Heading: "SKILLS" });
		}
	};

	return (
		<InView threshold={0.1} onChange={(inView, entry) => viewChange(inView)}>
			<div
				ref={pageRef}
				className="w-full md:w-10/12 m-auto grid grid-cols-1 justify-start items-start"
			>
				<motion.h4
					variants={headingVariant}
					initial="hide"
					animate={isInView ? "show" : "hide"}
					exit="hide"
					className="text-3xl text-green-600 border-l-8 border-green-600 pl-4 pt-6 h-24 tracking-wider"
				>
					<span
						className="text-gray-600 dark:text-gray-400 text-sm"
						ref={typedElementForSub}
					></span>
					<br />
					<span className="text-green-600" ref={typedElementForHeading}></span>
				</motion.h4>
				<motion.div
					variants={containerVariant}
					initial="hide"
					animate="show"
					className="text-gray-500 p-1 md:p-4 lg:p-10 my-8 bg-white rounded-3xl text-xs flex flex-wrap dark:text-gray-200 dark:bg-gray-600"
				>
					{skillsList &&
						skillsList.map((skill) => (
							<motion.div
								variants={itemVariant}
								key={skill.Name}
								className="w-20 h-24 flex flex-col justify-center rounded-lg p-2 text-center m-4 border border-gray-100 dark:border-gray-700 dark:bg-gray-700 space-y-1 hover:shadow-xl"
							>
								{skill.Image && (
									<img
										src={skill.Image}
										alt={skill.Name}
										className="mx-auto w-8 h-8"
										width="32"
										height="32"
									/>
								)}
								<h5 className="font-semibold text-xs">{skill.Name}</h5>
								{skill.Rating > 0 && (
									<div
										className="h-1.5 border border-gray-300 dark:border-gray-500 w-full rounded-full"
										style={{
											background: `linear-gradient(to right, ${skill.Color} ${
												10 * skill.Rating
											}%, white ${100 - 10 * skill.Rating}%)`,
										}}
									></div>
								)}
							</motion.div>
						))}
				</motion.div>
			</div>
		</InView>
	);
}
